import { MenuItem } from "@mui/material";

const DownloadFarmersData = ({
  districtValue,
  crop,
  setAnchorEl,
  setLoadingCsv,
}) => {
  const handleDownload = (url, filename, timeout = 1500) => {
    setAnchorEl(null);
    setLoadingCsv(true);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => setLoadingCsv(false), timeout);
  };

  const district_name = districtValue || "";
  const crop_name = crop || "";

  return (
    <>
      {/* <MenuItem
        onClick={() =>
          handleDownload(
            `https://onboarding.agrani.tech/api/v1/onboarding/baseline-assessment-csv?district_name=${district_name}&crop_name=${crop_name}`,
            "baseline-assessment.csv"
          )
        }
      >
        Farmer Data
      </MenuItem> */}

      <MenuItem
        onClick={() => {
          const timeout = crop_name ? 1000 : district_name ? 6500 : 13000;
          handleDownload(
            `https://onboarding.agrani.tech/api/v1/onboarding/baseline-assessment-csv?form_name=crop_level&district_name=${district_name}&crop_name=${crop_name}`,
            "baseline-assessment-crop.csv",
            timeout
          );
        }}
      >
        Crop Level
      </MenuItem>

      <MenuItem
        onClick={() =>
          handleDownload(
            `https://onboarding.agrani.tech/api/v1/onboarding/baseline-assessment-csv?form_name=economic&district_name=${district_name}&crop_name=${crop_name}`,
            "baseline-assessment-economic.csv",
            2000
          )
        }
      >
        Economic
      </MenuItem>

      <MenuItem
        onClick={() =>
          handleDownload(
            `https://onboarding.agrani.tech/api/v1/onboarding/baseline-assessment-csv?form_name=environmental&district_name=${district_name}&crop_name=${crop_name}`,
            "baseline-assessment-environmental.csv",
            2000
          )
        }
      >
        Environmental
      </MenuItem>

      <MenuItem
        onClick={() =>
          handleDownload(
            `https://onboarding.agrani.tech/api/v1/onboarding/baseline-assessment-csv?form_name=social&district_name=${district_name}&crop_name=${crop_name}`,
            "baseline-assessment-social.csv",
            1500
          )
        }
      >
        Social
      </MenuItem>
    </>
  );
};

export default DownloadFarmersData;
